import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCageDrIebkeeU3JRn0W2GGN35v0exNZjU",
  authDomain: "seevidev.firebaseapp.com",
  projectId: "seevidev",
  storageBucket: "seevidev.firebasestorage.app",
  messagingSenderId: "437980798094",
  appId: "1:437980798094:web:0806c6eaf3cb1ac9ec7ddf",
  measurementId: "G-ECGKBQ79EL"
};

export const firebaseApp = initializeApp(firebaseConfig);
export const analytics = getAnalytics(firebaseApp);
export const messaging = getMessaging(firebaseApp);
